export const deleteSelectedFlowTagsInformation = (flow, deletedindex) => {
  const tmpTags = [...flow.tags];
  tmpTags.splice(deletedindex, 1);

  return {
    ...flow,
    tags: tmpTags,
  };
};
